var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 22,
    viewBox: "0 0 15 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57699 11.6364H7.98753V9.52061H10.1033V8.11007H7.98753V5.99426H6.57699V8.11007H4.46118V9.52061H6.57699V11.6364Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8098 2.11581C10.8098 0.947705 9.86205 0 8.69394 0H5.87287C4.70476 0 3.75706 0.947705 3.75706 2.11581H0.230713V19.0423C0.230713 20.2104 1.17842 21.1581 2.34652 21.1581H12.2203C13.3884 21.1581 14.3361 20.2104 14.3361 19.0423V2.11581H10.8098ZM12.9256 19.0423C12.9256 19.4307 12.6087 19.7475 12.2203 19.7475H2.34652C1.95806 19.7475 1.64125 19.4307 1.64125 19.0423V3.52635H3.75706H5.1676V2.11581C5.1676 1.72735 5.48442 1.41054 5.87287 1.41054H8.69394C9.08241 1.41054 9.39921 1.72736 9.39921 2.11581V3.52635H12.9256V19.0423Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05249 14.1053H11.5157V15.5158H3.05249V14.1053Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05249 16.928H7.2841V18.3385H3.05249V16.928Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecords);
export default __webpack_public_path__ + "static/media/records.a4de1868efc336ddbd9a675b21cc621e.svg";
export { ForwardRef as ReactComponent };